import Login from '@/view/login/Login'

export default {
  path: '/login',
  name: 'Login',
  components: {
    default: Login
  }
}



// WEBPACK FOOTER //
// ./src/router/login/Login.js